import { IChatbotQuestion } from './question';

export enum ChatbotRequestType {
  MESSAGE = 'message',
  ANSWERS = 'answers',
}

export interface IChatbotBaseRequest {
  threadId: string;
}

export interface IChatbotMessageRequest extends IChatbotBaseRequest {
  type: typeof ChatbotRequestType.MESSAGE;
  message: string;
}

export interface IChatbotAnswersRequest extends IChatbotBaseRequest {
  type: typeof ChatbotRequestType.ANSWERS;
  answers: IChatbotQuestion[];
}

export type IChatbotRequest = IChatbotMessageRequest | IChatbotAnswersRequest;
